import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { cn } from "../../../utils/cn";

interface BackButtonProps {
  isDarkModeStyles?: boolean;
}

const BackButton = ({ isDarkModeStyles = true }: BackButtonProps) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <div
      onClick={() => navigate(-1)}
      className={cn("flex items-center gap-1 cursor-pointer border-b-2 border-transparent hover:border-purple-primary",
        isDarkModeStyles && "dark:text-white hover:dark:border-white"
      )}
    >
      {i18n.language === "en" ? (
        <ArrowLeft className="w-5" />
      ) : (
        <ArrowRight className="w-5" />
      )}
      <p className="text-sm">{t("back")}</p>
    </div>
  );
};

export default React.memo(BackButton);
